// @core/api/endpoints/localization/get_platform_locale_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformLocaleConfigResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Get platform locale config
 * Retrieves the platform's locale configuration including default locale, available locales, and fallback chain.
 * @public This endpoint does not require authentication
 */
export async function GetPlatformLocaleConfig(
  params?: {
  },
  options?: RequestOptions
): Promise<PlatformLocaleConfigResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/config`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<PlatformLocaleConfigResponse>(requestPath, { ...requestOptions, params });
}
